import { Component, OnInit ,ViewChild} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import {WxjssdkService} from 'src/service/wxjssdk.service';
declare var app;

@Component({
  selector: 'app-a2-milkcode-use-info',
  templateUrl: './a2-milkcode-use-info.component.html',
  styleUrls: ['./a2-milkcode-use-info.component.scss']
})
export class A2MilkcodeUseInfoComponent extends GridBaseCase {
  number = null;
  dataArrayList = [];
  isInit = false;
  pageName:any = "";
  placeholder:any = "请输入物流码";
  numberErrorTip:any = "请填写正确的物流码！";
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private weixin: WxjssdkService,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    public barcode: BarcodeScanner,
  ) { super();
    this.loading = true;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(this.pageName == 'IntegralCodeUseInfo'){
      //MilkCodeUseInfo 物流码name
      //IntegralCodeUseInfo 积分码name
      this.placeholder = "请输入积分码";
      this.numberErrorTip = "请填写正确的积分码！"
    }
  }

  searchEvent(e,type:any=""){
    if(e.keyCode == 13 || type=='search'){
      const code = new RegExp("^[0-9]*$");
      if(this.number != null && code.test(this.number.trim())){
        this.LoadSearchData();
      }else{
        this.msg.Alert(this.numberErrorTip);
      }
    }
  }

  LoadSearchData(){
    let that = this;
    that.loading = false;
    that.isInit = true;
    that.dataArrayList = [];
    /**{
     * 物流码追溯
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": "{\"code\":\"0048121810095060\"}",
      "ConfigName": "QueryTankUsage"
      }

     * 积分码追溯
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": "{\"code\":\"0048121810095060\"}",
      "ConfigName": "QueryTankUsage"
      }
    **/
    
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else if(that.pageName == 'MilkCodeUseInfo'){
      body.ConfigName="QueryTankUsage";
    }else if(that.pageName == 'IntegralCodeUseInfo'){
      body.ConfigName="GetIntegralCodeUsageInfo";
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RequestBody = JSON.stringify({"code":that.number.trim().toString()});
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.loading = true;
        that.apiObj['status'] = true;
        if(data.Status){
          that.dataArrayList.push(data.Status);
        }
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = app.ERRORMESSAGE;
      that.loading = true;
      console.log(error);
    });
 }

 scanQrcode() {
  const that = this;

  if (that.platform.is('cordova')) {
    // that.com.setHistoryUrl();
    that.barcode.scan().then((scan) => {
      // let sancanArray: Array<any> = new Array<any>();
      // sancanArray = that.com.GetStorageKey("backurl") || [];
      // sancanArray.splice(sancanArray.length - 1, 1);
      // localStorage.setItem("backurl", JSON.stringify(sancanArray));
      const _code = scan.text;
      if (_code && _code.indexOf("http") == -1) {
        const code = new RegExp("^[0-9]*$");
        that.number = _code;
        if(that.number != null && code.test(that.number)){
          that.LoadSearchData();
        }else{
          that.msg.Alert(that.numberErrorTip);
        }
      }else if(_code && _code.indexOf("http") > -1){
        let _param = _code.split("?");
        if(_param.length >= 2){
          let _qrCode = _param[1].split("=");
          if(_qrCode.length == 2 && _qrCode[1]){
            that.number = _qrCode[1];
            that.LoadSearchData();
          } else {
            that.msg.Alert(that.numberErrorTip);
          }
        } else {
          that.msg.Alert(that.numberErrorTip);
        }
      } else {
        that.msg.Alert(that.numberErrorTip);
      }
    }).catch(error => {
      that.msg.Show(error);
    });
  } else {
    if(that.com.IsWeixinBrowser){
      that.weixin.GetWxScanQRCode().then(scan=>{
        const _code = scan.Status;
        if (_code && _code.indexOf("http") == -1) {
          const code = new RegExp("^[0-9]*$");
          that.number = _code;
          if(that.number != null && code.test(that.number)){
            that.LoadSearchData();
          }else{
            that.msg.Alert(that.numberErrorTip);
          }
        }else if(_code && _code.indexOf("http") > -1){
          let _param = _code.split("?");
          if(_param.length >= 2){
            let _qrCode = _param[1].split("=");
            if(_qrCode.length == 2 && _qrCode[1]){
              that.number = _qrCode[1];
              that.LoadSearchData();
            } else {
              that.msg.Alert(that.numberErrorTip);
            }
          } else {
            that.msg.Alert(that.numberErrorTip);
          }
        } else {
          that.msg.Alert(that.numberErrorTip);
        }
      })
    }else{
      that.msg.Show("暂不支持", "middle");
    }
    
  }
}
}
